module.exports = __webpack_public_path__ + "static/img/menu.15f64477.svg";